import React from 'react'
import { Link } from 'react-router-dom';
import { Receipt } from 'lucide-react';
import { Header } from '../../../components/page-header/Header';

// There is no invoice history to show yet. (This page used to list made-up
// rows: "Template 01 … $2999", "Showing 2-2 of 1000".)
const UserInvoiceTable = () => {
    const breadcrumbItems = [
        { label: 'Dashboard', to: '/user-dashboard' },
        { label: 'All Invoices' },
    ];

    return (
        <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
            <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-6">
                <Header title="All Invoices" breadcrumbItems={breadcrumbItems} />

                <div className="bg-white rounded-xl shadow-md p-8 sm:p-12 flex flex-col items-center text-center">
                    <div className="bg-blue-50 p-4 rounded-full mb-4">
                        <Receipt className="w-10 h-10 text-blue-600" />
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">No invoices yet</h2>
                    <p className="text-gray-600 max-w-md">
                        When you subscribe to a plan, your invoices will be listed here.
                    </p>
                    <Link to="/user-dashboard/subscription" className="mt-5 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700">
                        See plans
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default UserInvoiceTable
